import {Box, Container, Hidden, makeStyles} from '@material-ui/core';
import {ButtonPurple} from 'components/Buttons';
import Typo from 'components/Typo';
import React from 'react';
import {Helmet} from 'react-helmet';
import {useHistory} from 'react-router-dom';
import Footer from 'screens/common/Footer';
import {iosVersion, rieltor} from 'styles/theme';
import {createDashboardUrl} from 'utils/navigation';
import {HeaderFallback} from './HeaderFallback';
import {getSeoTitle} from '../../utils';
import {useSelector} from 'react-redux';
import {seoPatternsSelector} from '../../store/global/selectors';

const useWhiteScreenStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('xs')]: {
      paddingBottom: theme.spacing(6),
    },
  },
  content: {
    minHeight: iosVersion >= 26 ? 'calc(100vh - 160px)' : 'calc(80vh - 160px)', // 100 % - header height
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: rieltor.grayLines,
  },
  newBg: {
    backgroundColor: rieltor.grayLines,
  },
  mainContainer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    padding: '16px',
    backgroundColor: rieltor.grayLines,
  },
  fallbackWrapper: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    rowGap: '20px',
  },
  backButton: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '245px',
    height: '52px',
    fontSize: '20px',
    backgroundColor: rieltor.purple,
    border: '1px solid transparent',
    borderRadius: '8px',
    color: '#fff',
    textDecoration: 'none !important',
    padding: '8px 14px',
    fontFamily: rieltor.fontFamily,
    fontWeight: 700,
    '&:hover': {
      backgroundColor: 'transparent',
      borderColor: rieltor.purple,
      color: rieltor.purple,
    },
  }
}));

interface WhiteScreenFallbackProps {
  onClose: () => void;
}

export const WhiteScreenFallback = ({
  onClose
}: WhiteScreenFallbackProps) => {
  const classes = useWhiteScreenStyles();

  return (
    <Box className={classes.root}>
      <HeaderFallback/>
      <Box className={`${classes.content}`}>
        <WhiteScreenBody onClose={onClose}/>
      </Box>

      <Hidden xsDown>
        <Footer/>
      </Hidden>
    </Box>
  );
};

const WhiteScreenBody = ({
  onClose
}: WhiteScreenFallbackProps) => {
  const classes = useWhiteScreenStyles();
  const history = useHistory();
  const seoPatterns = useSelector(seoPatternsSelector);

  return (
    <>
      {iosVersion >= 26 && <Box style={{backgroundColor: rieltor.mainBg, position: 'fixed', top: 0, left: 0, width: '100%', minHeight: 6, zIndex: 100}}></Box>}

      <Helmet>
        <title>{getSeoTitle(seoPatterns || [], '/error') || 'Помилка'}</title>
      </Helmet>
      <Container maxWidth="xl" className={classes.mainContainer}>
        <div className={classes.fallbackWrapper}>
          <img
            src={require('./bot.png')}
            alt={'404 bot'}
            style={{height: 150, width: 150, marginBottom: 45}}
          />

          <Typo variant={'title0'} style={{fontSize: 30}}>
            Щось пішло не так
          </Typo>

          <Typo variant={'title2'} style={{fontWeight: 500, lineHeight: '30px', textAlign: 'center'}}>
            Ця сторінка недоступна або стала неактуальною.<br/>
            Спробуйте повернутись на головну сторінку кабінету
          </Typo>

          <ButtonPurple
            className={classes.backButton}
            onClick={() => {
              onClose();
              history.replace(createDashboardUrl({}));
            }}
          >
            На головну
          </ButtonPurple>
        </div>
      </Container>
    </>
  );
};
